import React, { useEffect, useState } from "react";
import * as MatStyled from "@mui/material/styles";
import FileUploadIcon from "@mui/icons-material/FileUpload";

import { CSVLink } from "react-csv";
import Stack from "@mui/material/Stack";
import { DataGrid } from "@mui/x-data-grid";
import styled from "styled-components";
// import { useNavigate } from "react-router-dom";
import HistoryIcon from "@mui/icons-material/History";
import moment from "moment";
import { Button } from "@mui/material";
import { getAllLogs } from "src/api/log";
import { useParams } from "react-router-dom";
import { useAuth } from "src/hooks/useAuth";

const WrapperButton = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;
  width: 200px;
  margin-left: auto;

  .Button-Add {
    color: #ffffff;
    width: 100%;
    background: #e04132;
    box-shadow:
      0px 3px 1px -2px rgba(0, 0, 0, 0.2),
      0px 2px 2px rgba(0, 0, 0, 0.14),
      0px 1px 5px rgba(0, 0, 0, 0.12);
    border-radius: 16px;
    height: 52px;
    padding: 0 16px;
  }
  .Button-Add:focus {
    background-color: #e04132;
  }
  .Button-Add:hover {
    background-color: #e04132;
    opacity: 0.9;
  }
  .Button-Add:disabled {
    background-color: #f2f1f3;
    opacity: 0.9;
  }
`;

const DivMuiName = styled.div`
  width: 100%;
  height: auto;
  padding: 32px;
  border-radius: 32px;
  background-color: #ffffff;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  // display: flex;
  justify-content: center;
  align-items: center;
`;

const DivMuiInside = styled.div`
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const WrapperText = styled.div`
  // margin-bottom: 32px;
  width: 70%;
  position: relative;
  display: flex;
  justify-content: flex-start;
  .TextField-without-border-radius fieldset {
    border-radius: 16px;
  }
`;
// const WrapperStatus = styled.div`
//   width: 25%;
//   position: relative;
//   display: flex;
//   justify-content: center;
//   margin-top: 8px;
//   .TextField-without-border-radius fieldset {
//     border-radius: 16px;
//   }
// `;

const WrapperDataGrid = styled.div`
  height: 600px;
  width: 100%;
  .MuiDataGrid-root {
    border: 1px solid #ffffff;
  }
  .MuiDataGrid-columnHeaders {
    background-color: #f5f5f5;
  }
  .MuiDataGrid-root .MuiDataGrid-columnSeparator--sideRight {
    color: #f5f5f5;
  }
  .MuiDataGrid-root .MuiDataGrid-columnHeader:focus-within {
    // outline: solid #f5f5f5 1px;
    outline: none;
  }
  .MuiDataGrid-root .MuiDataGrid-cell:focus {
    outline: none;
    border-bottom: solid #f5f5f5 1px 0 1px 0;
  }
  .MuiDataGrid-root .MuiDataGrid-row.Mui-selected {
    background-color: #ffffff;
  }
`;
const SpanProductName = styled.span`
  color: #252525;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
`;
const ImageNoData = styled.image`
  width: 120px;
  height: 120px;
  background-image: url("https://xsurface-images.s3.ap-southeast-1.amazonaws.com/no+data.svg");
  background-repeat: no-repeat;
  background-size: 100%;
`;
const ImageNotFound = styled.image`
  width: 120px;
  height: 120px;
  background-image: url("https://xsurface-images.s3.ap-southeast-1.amazonaws.com/not+found.svg");
  background-repeat: no-repeat;
  background-size: 100%;
`;
const SpanTextCount = styled.span`
  font-weight: 400;
  font-size: 1rem;
  color: #000000;
  margin-right: 16px;
  min-width: 125px;
`;
const TextNoData = styled.pre`
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
`;
const drawerWidth = 260;

const Main = MatStyled.styled("main", {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  position: "relative",
  flexGrow: 1,
  padding: theme.spacing(3),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `-${drawerWidth}px`,
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
    position: "relative",
  }),
}));

const DrawerHeader = MatStyled.styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
  height: "75px",
}));

function ProductLogList({ open }) {
  const { user } = useAuth();
  // const navigate = useNavigate();
  let { itemcode } = useParams();

  const [logDataList, setLogDataList] = useState([]);
  const [logDataCSVList, setLogDataCSVList] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingLog, setIsLoadingLog] = useState(false);
  const [dataSearch, setDataSearch] = useState({
    module: "product",
    action: null,
    action_name: null,
    action_by: null,
    start_date: null,
    end_date: null,
    page: null,
    page_size: 10,
  });
  const [rowCount, setRowCount] = useState(0);

  // function CustomPagination() {
  //   const apiRef = useGridApiContext();
  //   const page = useGridSelector(apiRef, gridPageSelector);
  //   const pageCount = useGridSelector(apiRef, gridPageCountSelector);
  //   return (
  //     <WrapperPagination>
  //       <Pagination
  //         color="primary"
  //         count={pageCount}
  //         page={page + 1}
  //         onChange={(event, value) => apiRef.current.setPage(value - 1)}
  //       />
  //     </WrapperPagination>
  //   );
  // }

  const columns = [
    {
      field: "createdAt",
      headerName: "Date: Time",
      flex: 1,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params, index) => {
        return (
          <div className="rowitem">
            {params?.row?.createdAt
              ? moment(params?.row?.createdAt).format("YYYY-MM-DD HH:mm")
              : "-"}
          </div>
        );
      },
    },

    {
      field: "action",
      headerName: "Action",
      flex: 1,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return <div className="rowitem">{params?.row?.action}</div>;
      },
    },

    {
      field: "action_name",
      headerName: "Product",
      flex: 1,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return <div className="rowitem">{params?.row?.action_name}</div>;
      },
    },

    {
      field: "action_by",
      headerName: "Action by",
      flex: 1,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return <div className="rowitem">{params?.row?.action_by?.email}</div>;
      },
    },
  ];

  function NoRowsOverlay() {
    return (
      <Stack height="100%" alignItems="center" justifyContent="center">
        <ImageNoData></ImageNoData>
        <TextNoData>No Data</TextNoData>
      </Stack>
    );
  }

  function NoResultsOverlay() {
    return (
      <Stack height="100%" alignItems="center" justifyContent="center">
        <ImageNotFound></ImageNotFound>
        <TextNoData>Not Found</TextNoData>
      </Stack>
    );
  }

  const handlePageChange = (newPage) => {
    // We have the cursor, we can allow the page transition.
    setDataSearch({ ...dataSearch, page: newPage });
  };

  // useEffect(() => {
  //   if (itemcode === undefined) return;
  //   setDataSearch({ ...dataSearch, action_name: itemcode });
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [itemcode]);

  useEffect(() => {
    setIsLoading(true);
    if (itemcode === undefined) {
      (async () => {
        if (user.role_id === 1) {
          const { data } = await getAllLogs(dataSearch);
          setLogDataList(data.rows);
          setRowCount(data.count);
          setIsLoading(false);
        }
      })();
    } else {
      (async () => {
        if (user.role_id === 1) {
          const { data } = await getAllLogs({
            ...dataSearch,
            action_name: itemcode,
          });
          setLogDataList(data.rows);
          setRowCount(data.count);
          setIsLoading(false);
        }
      })();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSearch.page, dataSearch.action_name]);

  useEffect(() => {
    setIsLoadingLog(true);

    if (itemcode === undefined) {
      (async () => {
        if (user.role_id === 1) {
          const { data } = await getAllLogs({
            ...dataSearch,
            page_size: 99999,
          });
          setLogDataCSVList(data.rows);
          setIsLoadingLog(false);
        }
      })();
    } else {
      (async () => {
        if (user.role_id === 1) {
          const { data } = await getAllLogs({
            ...dataSearch,
            action_name: itemcode,
            page_size: 99999,
          });
          setLogDataCSVList(data.rows);
          setIsLoadingLog(false);
        }
      })();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSearch.action_name]);

  const exportToCSV = () => {
    const exportcsv = document.getElementById("export-csv");
    exportcsv.click();
  };
  return (
    <>
      <Main open={open}>
        <DrawerHeader />
        <DivMuiName>
          <DivMuiInside>
            <WrapperText>
              <HistoryIcon style={{ marginRight: "8px" }} />
              <SpanTextCount
              // style={{ textDecoration: "underline" }}
              >
                Product history
              </SpanTextCount>
              <SpanProductName>{itemcode ? itemcode : ""}</SpanProductName>
            </WrapperText>

            <WrapperButton>
              <Button
                className="Button-Add"
                startIcon={<FileUploadIcon />}
                onClick={() => exportToCSV()}
                disabled={isLoadingLog}
              >
                Export To CSV
              </Button>
              <CSVLink
                id="export-csv"
                style={{
                  display: "none",
                  fontWeight: "500",
                  fontSize: "15px",
                  alignItems: "center",
                  color: "#ffffff",
                  background: "e04132",
                  fontStyle: "normal",
                }}
                data={logDataCSVList.map((data) => {
                  const { _id, action_detail, __v, ...rest } = data;
                  return {
                    ...rest,
                    action_by: data.action_by?.email,
                    createdAt: data
                      ? moment(data.createdAt).format("YYYY-MM-DD HH:mm")
                      : "-",
                    updatedAt: data
                      ? moment(data.updatedAt).format("YYYY-MM-DD HH:mm")
                      : "-",
                  };
                })}
                // data={"mock mock mock"}
                filename={`log-list-${moment(new Date()).format(
                  "DD-MM-YYYY",
                )}.csv`}
                // headers={headers}
                // onClick={(event, done) => {
                //   if (quotationListData?.length === 0) {
                //     return false;
                //   }
                // }}
              >
                Export To CSV
              </CSVLink>
            </WrapperButton>
          </DivMuiInside>

          <WrapperDataGrid>
            <DataGrid
              rows={logDataList}
              getRowId={(row) => row._id}
              // getRowHeight={() => "auto"}
              loading={isLoading}
              columns={columns}
              pageSize={10}
              rowCount={rowCount}
              paginationMode="server"
              page={dataSearch.page}
              onPageChange={(e) => handlePageChange(e)}
              rowsPerPageOptions={[10]}
              pagination
              disableSelectionOnClick
              // localeText={{
              //   footerRowSelected: CustomPagination,
              // }}
              components={{
                // Footer: CustomPagination,
                NoRowsOverlay,
                NoResultsOverlay,
              }}
              componentsProps={{
                basePopper: {},
              }}
              sx={{
                "& .MuiDataGrid-actionsCell": {
                  transform: "rotate(90deg)",
                },
              }}
            />
          </WrapperDataGrid>
        </DivMuiName>
      </Main>
    </>
  );
}

export default ProductLogList;
